// Brand button. Matches the site's .btn / .btn-fire / .btn-outline styles.
// Variants: primary (fire), ink, outline, ghost. Sizes: sm, md, lg.

import React from 'react';

const variantClass = {
  primary: 'btn btn-fire',
  ink: 'btn btn-ink',
  outline: 'btn btn-outline',
  ghost: 'btn btn-ghost',
};

const sizeClass = {
  sm: 'btn-sm',
  md: '',
  lg: 'btn-lg',
};

export const BrandButton = React.forwardRef(function BrandButton(
  {
    variant = 'primary',
    size = 'md',
    className = '',
    fullWidth = false,
    children,
    ...rest
  },
  ref,
) {
  const cls = [
    variantClass[variant] || variantClass.primary,
    sizeClass[size] || '',
    fullWidth ? 'w-full' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');
  return (
    <button ref={ref} className={cls} {...rest}>
      {children}
    </button>
  );
});

export default BrandButton;
